import React, { Component } from 'react'
import Grid from '../components/Grid'
import './Home.css'

class Home extends Component {
  constructor (props) {
    super(props)

    this.state = {
      projects: {},
      sort: -1
    }
  }

  componentWillMount () {
    return this.props.changeHeaderColors('#545352', '#efeae6')
  }

  componentWillReceiveProps (nextProps) {
    if (Object.keys(this.state.projects).length !== 0) return false
    if (Object.keys(nextProps.projects).length === 0) return false

    this.setState({
      projects: nextProps.projects
    })

    return true
  }

  filterByYears () {
    this.setState({
      projects: this.props.projects,
      sort: -1
    })
  }

  filterByCategory () {
    const years = Object.keys(this.props.projects)

    let sortProjects = {}
    years.forEach(year => {
      this.props.projects[year].forEach(project => {
        if (Object.keys(sortProjects).indexOf(project.category) === -1) sortProjects[project.category] = []

        sortProjects[project.category].push(project)
      })
    })

    this.setState({
      projects: sortProjects,
      sort: 1
    })
  }

  filterByAlpha () {
    const years = Object.keys(this.props.projects)
    const groups = ['ABC', 'DEF', 'GHI', 'JKL', 'MNO', 'PQR', 'STU', 'VWX', 'YZ']

    let sortProjects = {}
    years.forEach(year => {
      this.props.projects[year].forEach(project => {
        const group = groups.find(letters => letters.indexOf(project.name.charAt(0)) !== -1)
        if (Object.keys(sortProjects).indexOf(group) === -1) sortProjects[group] = []

        sortProjects[group].push(project)
      })
    })

    function compare (a, b) {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    }

    Object.keys(sortProjects).forEach(group => sortProjects[group].sort(compare))

    this.setState({
      projects: sortProjects,
      sort: 1
    })
  }

  render () {
    return (
      <div className='content columns'>
        <div className='sidebar'>
          <div className='sidebarContent' style={{ borderRight: `0.2rem solid #545352` }}>
            <div className='text selectBy'>SELECT BY:</div>
            <div className='selectByBorder' />
            <form>
              <div onClick={() => this.filterByYears()}>
                <input id='year' type='radio' name='filters' value='year' defaultChecked />
                <label htmlFor='year'>YEAR</label>
              </div>
              <div onClick={() => this.filterByAlpha()}>
                <input id='abc' type='radio' name='filters' value='abc' />
                <label htmlFor='abc'>ABC</label>
              </div>
              <div onClick={() => this.filterByCategory()}>
                <input id='categ' type='radio' name='filters' value='categ' />
                <label htmlFor='categ'>CATEG.</label>
              </div>
            </form>
          </div>
        </div>
        <div className='column'>
          <Grid projects={this.state.projects} sort={this.state.sort} />
        </div>
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/pages/Home.js